import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

import { GameCharacter } from '../../../../models/Base';

import styles from './HandWritingBlankUnit.module.css';

type HandWritingBlankUnitProps = {
  character: GameCharacter<false>;
  isAnswered: boolean;
  isHighlighted: boolean;
  score: number;
  globalBlankIndex: number;
  isLearner: boolean;
  blankRefs: React.MutableRefObject<(HTMLDivElement | null)[]>;
};

enum AnswerState {
  notAnswered,
  FullReveal,
  LearnerFullReveal,
}

export const HandWritingBlankUnit: React.FC<HandWritingBlankUnitProps> = ({
  character,
  isAnswered,
  isHighlighted,
  score,
  globalBlankIndex,
  isLearner,
  blankRefs,
}) => {
  let backgroundColor = '#FF595933';
  if (score > 95) {
    backgroundColor = '#00A69826';
  } else if (score > 50) {
    backgroundColor = '#F6921E26';
  }

  const [answerState, setAnswerState] = useState<AnswerState>(
    AnswerState.notAnswered,
  );

  useEffect(() => {
    if (isAnswered && isLearner) {
      setAnswerState(AnswerState.LearnerFullReveal);
    } else if (isAnswered) {
      setAnswerState(AnswerState.FullReveal);
    } else {
      setAnswerState(AnswerState.notAnswered);
    }
  }, [isAnswered, isLearner]);

  const handleAnimationComplete = () => {
    // onCompleted();
  };

  return (
    <div
      ref={(el) => (blankRefs.current[globalBlankIndex] = el)}
      className={styles.blankContainer}
    >
      {answerState === AnswerState.FullReveal ? (
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, type: 'spring', stiffness: 100 }}
          className={styles.blankSquare}
          style={{ backgroundColor }}
          onAnimationComplete={handleAnimationComplete}
        >
          {character.character}
        </motion.span>
      ) : answerState === AnswerState.LearnerFullReveal ? (
        <span
          className={`${styles.blankSquare} ${
            isHighlighted ? styles.current : ''
          }`}
        >
          {character.character}
        </span>
      ) : (
        <span
          className={`${styles.blankSquare} ${styles.blankSquareChar} ${
            isHighlighted ? styles.current : ''
          }`}
        >
          {character.character}
        </span>
      )}
    </div>
  );
};
